import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'
import AccommodationMobileHeaderFilters from 'components/OfferPage/Accommodation/AccommodationMobileHeaderFilters'
import { mediaQueryUp } from 'components/utils/breakpoint'

const MobileStickyHeader = styled.div`
  position: sticky;
  top: 0;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  box-shadow: ${props => props.theme.shadow.bottom.small};
  z-index: ${zIndex.stickyFooter};

  padding: ${rem(8)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

interface Props {
  children?: React.ReactNode;
}

function AccommodationOfferPageStickyHeaderMobile({ children }: Props) {
  return (
    <MobileStickyHeader>
      {children}
      {/* TODO: Remove this once fully migrated to children system */}
      {!children && <AccommodationMobileHeaderFilters />}
    </MobileStickyHeader>
  )
}

export default AccommodationOfferPageStickyHeaderMobile
